var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergencyContactDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 20V18H6.6L8.575 11.425C8.70833 10.9917 8.95433 10.646 9.313 10.388C9.67167 10.13 10.0673 10.0007 10.5 10H13.5C13.9333 10 14.3293 10.1293 14.688 10.388C15.0467 10.6467 15.2923 10.9923 15.425 11.425L17.4 18H19V20H5ZM11 8V3H13V8H11ZM16.95 10.475L15.525 9.05L19.075 5.525L20.475 6.925L16.95 10.475ZM18 15V13H23V15H18ZM7.05 10.475L3.525 6.925L4.925 5.525L8.475 9.05L7.05 10.475ZM1 15V13H6V15H1Z",
    fill: "#5981E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyContactDetails);
export default __webpack_public_path__ + "static/media/emergency_contact_details.559780017f6362d0b15394f157000843.svg";
export { ForwardRef as ReactComponent };